<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      resetState: 'filter/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
};
</script>

<template>
  <div class="filter-wrapper">
    <v-content>
      <router-view/>
    </v-content>
  </div>
</template>

<style lang="scss">
  .filter-wrapper {
    &__spinner {
      height: calc(100vh - 64px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FilterWrapper.vue